// extracted by mini-css-extract-plugin
export default {"mainContainer":"PrivacyPolicyPage_mainContainer__6zRAp","spacingContainer":"PrivacyPolicyPage_spacingContainer__kzkCy"};